import api from "./axios";

const BASE = "/inventory";

export const getInventoryKpis = async (params = {}) => {
  return api.get(`${BASE}/kpis`, { params });
};

export const listInventoryPartners = async (params = {}) => {
  return api.get(`${BASE}/partners`, { params });
};

export const exportInventory = async (params = {}) => {
  return api.get(`${BASE}/export`, {
    params,
    responseType: "blob",
  });
};
